module.exports = __webpack_public_path__ + "img/icon-fb.9168b29a.svg";